import { useState, useEffect, useRef } from "preact/hooks";
import type { StoreApi } from "zustand/vanilla";

export function useStore<T, U>(store: StoreApi<T>, selector: (state: T) => U): U {
  const selectorRef = useRef(selector);
  selectorRef.current = selector;

  const [slice, setSlice] = useState(() => selector(store.getState()));

  useEffect(() => {
    const unsub = store.subscribe((state) => {
      setSlice(selectorRef.current(state));
    });
    // Sync in case store changed between render and effect
    setSlice(selectorRef.current(store.getState()));
    return unsub;
  }, [store]);

  return slice;
}
